/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Player_Not_Checked_InInputs */



/**
* | output |
* | --- |
* | "Player is not checked in" |
*
* @param {Err_Tournament_Player_Not_Checked_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_player_not_checked_in = /** @type {((inputs?: Err_Tournament_Player_Not_Checked_InInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Player_Not_Checked_InInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le joueur n'a pas pointé")
	if (locale === "es") return /** @type {LocalizedString} */ ("El jugador no ha hecho el check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O jogador não fez check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il giocatore non ha fatto il check-in")
	return /** @type {LocalizedString} */ ("Player is not checked in")
});